import useDocumentEventListener from './useDocumentEventListener';

export default useDocumentEventListener;
